/**
 * Per-environment DSP / WDSSO configuration. APP_ENV selects the environment at
 * build time. Non-prod environments share the UAT DSP host; PROD uses the production
 * DSP host.
 */

import {
  DSP_REALM,
  DSP_SERVICE,
} from './constants';

const DSP_BASE_NONPROD = 'https://cmb-staff-dsp-uat.hk.hsbc:8443';
const DSP_BASE_PROD = 'https://cmb-staff-dsp.hk.hsbc:8443';

// Only SIT/UAT/PROD are supported; any other APP_ENV falls back to the non-prod value.
const DSP_BASE_BY_ENV = {
  SIT: DSP_BASE_NONPROD,
  UAT: DSP_BASE_NONPROD,
  PROD: DSP_BASE_PROD,
};

// SSO backend internal-proxy host. DSP users reach the backend through this gateway
// (which trusts the DSP session cookie) instead of the Cognito proxy path.
const SSO_API_HOST_NONPROD = 'https://digitaldev-int-rbwm.hk.hsbc';
const SSO_API_HOST_PROD = 'https://digitalprod-int-rbwm.hk.hsbc';

const SSO_API_HOST_BY_ENV = {
  SIT: SSO_API_HOST_NONPROD,
  UAT: SSO_API_HOST_NONPROD,
  PROD: SSO_API_HOST_PROD,
};

/** Return the SSO backend (internal-proxy) host for the current environment. */
export const getSsoApiHost = () => {
  const env = (typeof APP_ENV !== 'undefined' && APP_ENV) || 'SIT';
  return SSO_API_HOST_BY_ENV[env] || SSO_API_HOST_NONPROD;
};

/** Return the DSP/SSO configuration for the current environment. */
export const getSsoConfig = () => {
  const env = (typeof APP_ENV !== 'undefined' && APP_ENV) || 'SIT';
  const dspBaseUrl = DSP_BASE_BY_ENV[env] || DSP_BASE_NONPROD;

  return {
    dspBaseUrl,
    realm: DSP_REALM,
    service: DSP_SERVICE,
  };
};

/** Build the WDSSO staff authentication URL. */
export const getDspAuthenticateUrl = () => {
  const { dspBaseUrl, realm, service } = getSsoConfig();
  return `${dspBaseUrl}/dsp/dspAuthenticate.jsp?realm=${realm}&service=${service}`;
};

/** Build the DSP session-info URL. */
export const getDspSessionInfoUrl = () => {
  const { dspBaseUrl } = getSsoConfig();
  return `${dspBaseUrl}/dsp/json/sessions?_action=getSessionInfo`;
};

/** Build the DSP user-info URL for a given username. */
export const getDspUserInfoUrl = (username) => {
  const { dspBaseUrl } = getSsoConfig();
  return `${dspBaseUrl}/dsp/json/realms/root/realms/staff/users/${encodeURIComponent(username)}`;
};

export default getSsoConfig;
